import React, {useEffect, useRef} from "react";
import gsap from "gsap";
import isMobile from "ismobilejs";

export default function Graph() {
    const wrapper = useRef(null);

    useEffect(() => {
        const infos = document.querySelectorAll('.graph--info');

        gsap.set('.graph--info rect', {
            width: 110,
            opacity: 0
        });

        gsap.set('.graph--info circle', {
            scale: 0,
            x: 0, y: 0,
            transformOrigin: '50% 50%',
            svgOrigin: '55 55',
        });

        gsap.set('.graph--info text', {
            opacity: 0
        });

      setTimeout(() => {

          Object.values(infos).map((item, index) =>
              gsap.timeline({
                  scrollTrigger: {
                      trigger: '.svg',
                      start:"top 50%",
                      end:"bottom bottom",
                      toggleActions: "play none none none"
                  }
              })
                  .to(item.querySelector('circle'), 1, {
                      scale: 1,
                      transformBox: 'fill-box',
                      delay: .2 * index,
                      onComplete: () => {
                          gsap.to(item.querySelector('rect'), .8, {
                              width: 370,
                              opacity: 1,
                              onComplete: () => {
                                  gsap.to(item.querySelectorAll('text'), .3, {
                                      opacity: 1
                                  })
                              }
                          });
                      }
                  })
          )

      }, 3000)
    }, []);

    const svg = `
<svg class="svg" style="${!isMobile().phone ? `margin: 0 auto; display: block;` : ''}" width="783px" height="630px" viewBox="0 0 783 630" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-15.000000, 0.000000)">
            <g transform="translate(0.000000, 118.000000)" class="graph--main-info">
                <circle fill="#2E377F" cx="180" cy="165" r="165"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="26" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                    <tspan x="103.0625" y="76">Les voitures</tspan>
                    <tspan x="65.8334961" y="106">autonomes feront </tspan>
                    <tspan x="54.8457031" y="136">économiser au total</tspan>
                    <tspan x="320.859375" y="136" font-size="28"/>
                    <tspan x="180" y="166" font-family="OpenSans-Bold, Open Sans" font-size="65" font-weight="bold" line-spacing="40"/>
                    <tspan x="90.2841797" y="204.524902" font-family="OpenSans-Bold, Open Sans" font-size="65" font-weight="bold" line-spacing="40">1.300</tspan>
                    <tspan x="263.47168" y="206" font-family="OpenSans-Bold, Open Sans" font-size="35" font-weight="bold" line-spacing="40"/>
                    <tspan x="65.609375" y="246" line-spacing="32">milliards de dollars</tspan>
                </text>
            </g>
            <g transform="translate(338.000000, 0.000000)" class="graph--info">
                <rect fill="#8593C7" x="0" y="0" width="320" height="110" rx="55"/>
                <circle fill="#4C58B6" cx="55" cy="55" r="55"/>
                <text font-family="OpenSans-Bold, Open Sans" font-size="40" font-weight="bold" line-spacing="20" fill="#FFFFFF">
                    <tspan x="17" y="55">488</tspan>
                    <tspan x="93.2617188" y="100.753906" font-family="OpenSans-Semibold, Open Sans" font-size="24" font-weight="500"/>
                    <tspan x="13.3085938" y="75.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">milliards de</tspan>
                    <tspan x="29.1679688" y="90.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">dollars</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" line-spacing="22" fill="#FFFFFF">
                    <tspan x="129" y="40">d’économies </tspan>
                    <tspan x="129" y="62">totales grâce aux </tspan>
                    <tspan x="129" y="84">accidents évités</tspan>
                </text>
            </g>
            <g transform="translate(408.000000, 130.000000)" class="graph--info">
                <rect fill="#8593C7" x="0" y="0" width="380" height="110" rx="55"/>
                <circle fill="#4C58B6" cx="55" cy="55" r="55"/>
                <text font-family="OpenSans-Bold, Open Sans" font-size="40" font-weight="bold" line-spacing="20" fill="#FFFFFF">
                    <tspan x="17" y="55">507</tspan>
                    <tspan x="93.2617188" y="100.753906" font-family="OpenSans-Semibold, Open Sans" font-size="24" font-weight="500"/>
                    <tspan x="13.3085938" y="75.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">milliards de</tspan>
                    <tspan x="29.1679688" y="90.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">dollars</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" line-spacing="22" fill="#FFFFFF">
                    <tspan x="130" y="40">de gains de productivité </tspan>
                    <tspan x="130" y="62">grâce à la voiture </tspan>
                    <tspan x="130" y="84">autonome</tspan>
                </text>
            </g>
            <g transform="translate(428.000000, 260.000000)" class="graph--info">
                <rect fill="#8593C7" x="0" y="0" width="370" height="110" rx="55"/>
                <circle fill="#4C58B6" cx="55" cy="55" r="55"/>
                <text font-family="OpenSans-Bold, Open Sans" font-size="40" font-weight="bold" line-spacing="20" fill="#FFFFFF">
                    <tspan x="17" y="55">138</tspan>
                    <tspan x="93.2617188" y="100.753906" font-family="OpenSans-Semibold, Open Sans" font-size="24" font-weight="500"/>
                    <tspan x="13.3085938" y="75.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">milliards de</tspan>
                    <tspan x="29.1679688" y="90.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">dollars</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" line-spacing="22" fill="#FFFFFF">
                    <tspan x="136" y="39">de gains de </tspan>
                    <tspan x="136" y="61">productivité grâce aux </tspan>
                    <tspan x="136" y="83">embouteillages évités</tspan>
                </text>
            </g>
            <g transform="translate(368.000000, 390.000000)" class="graph--info">
                <rect fill="#8593C7" x="0" y="0" width="359" height="110" rx="55"/>
                <circle fill="#4C58B6" cx="55" cy="55" r="55"/>
                <text font-family="OpenSans-Bold, Open Sans" font-size="40" font-weight="bold" line-spacing="20" fill="#FFFFFF">
                    <tspan x="30" y="55">11</tspan>
                    <tspan x="77.8320312" y="78" font-family="OpenSans-Semibold, Open Sans" font-size="24" font-weight="500"/>
                    <tspan x="15.29492188" y="75.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">milliards de</tspan>
                    <tspan x="30.1542969" y="90.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">dollars</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" line-spacing="22" fill="#FFFFFF">
                    <tspan x="130" y="40">d’économies de </tspan>
                    <tspan x="130" y="62">carburant grâce aux </tspan>
                    <tspan x="130" y="84">embouteillages évités</tspan>
                </text>
            </g>
            <g transform="translate(253.000000, 520.000000)" class="graph--info">
                <rect fill="#8593C7" x="0" y="0" width="289" height="110" rx="55"/>
                <circle fill="#4C58B6" cx="55" cy="55" r="55"/>
                <text font-family="OpenSans-Bold, Open Sans" font-size="40" font-weight="bold" line-spacing="20" fill="#FFFFFF">
                    <tspan x="17" y="55">158</tspan>
                    <tspan x="93.2617188" y="100.753906" font-family="OpenSans-Semibold, Open Sans" font-size="24" font-weight="500"/>
                    <tspan x="13.3085938" y="75.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">milliards de</tspan>
                    <tspan x="29.1679688" y="90.753906" font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="18">dollars</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" line-spacing="22" fill="#FFFFFF">
                    <tspan x="130" y="50">d’économies</tspan>
                    <tspan x="130" y="72">de carburant</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;

    return (
        <div dangerouslySetInnerHTML={{__html: svg}} ref={wrapper}/>
    )
}
